// Theme central de la app. Cualquier color, espaciado o tamaño que aparezca
// en un styled component sale de aquí. Nunca colores hardcoded en componentes.

export const theme = {
  color: {
    background: "#fafafa",
    surface: "#ffffff",
    border: "#e0e0e0",
    borderStrong: "#cccccc",

    textPrimary: "#1a1a1a",
    textMuted: "#666666",
    textDim: "#999999",

    accent: "#0066cc",
    accentHover: "#0052a3",
    accentMuted: "#e6f0fa",
    accentHedge: "#bedd69",

    success: "#16a34a",
    successMuted: "#dcfce7",
    warning: "#d97706",
    warningMuted: "#fef3c7",
    error: "#dc2626",
    errorMuted: "#fee2e2",
  },
  space: {
    xs: "0.25rem",
    sm: "0.5rem",
    md: "1rem",
    lg: "1.5rem",
    xl: "2rem",
    xxl: "3rem",
  },
  radius: {
    sm: "4px",
    md: "6px",
    lg: "10px",
  },
  font: {
    family:
      'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    mono: 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace',
    size: {
      xs: "0.75rem",
      sm: "0.875rem",
      md: "1rem",
      lg: "1.125rem",
      xl: "1.5rem",
      xxl: "2rem",
    },
    weight: {
      normal: 400,
      medium: 500,
      bold: 600,
    },
  },
  shadow: {
    sm: "0 1px 2px rgba(0, 0, 0, 0.04)",
    md: "0 2px 8px rgba(0, 0, 0, 0.06)",
  },
  layout: {
    maxWidth: "780px",
  },
} as const;

export type Theme = typeof theme;

// Augmentation de DefaultTheme de styled-components para que useTheme()
// y los template strings tengan tipado completo.
declare module "styled-components" {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  export interface DefaultTheme extends Theme {}
}
